export default __webpack_public_path__ + "static/media/lobby-lg.3d667547.jpg";